import styled from "styled-components";
import { CssRule } from "../../../../themes/architecture/css-helpers/css-rule";

interface LiveStreamingNavigationProps {
    isActive: boolean;
}

const LiveStreamingNavigationCommonBox = styled.div<LiveStreamingNavigationProps>`
    position: absolute;
    top: 35%;
    width: 3rem;
    height: 3rem;
    opacity: ${({isActive}) => isActive ? "1" : "0.25"};
    cursor: pointer;
    @media ${({theme}) => theme.mediaQuery.xlAndAbove} {
        /* On PC, one tile is a third of the swiper, but the ones not in center are scaled to 0.7  */
        /* So ... height is 100 * 0.7 */
        height: 70%;
        /* top is 100 * (1-0.7) / 2 */
        top: 15%;
        /* 23.331 is 33.33*0.7 */
        width: 23.331%;
    }
`;

export const LiveStreamingNavigationPrevButtonDefaultBox = styled(LiveStreamingNavigationCommonBox)`
    left: 1rem;
    @media ${({theme}) => theme.mediaQuery.xlAndAbove} {
        /* On PC, one tile is a third of the swiper, but the ones not in center are scaled to 0.7  */
        /* left is 33.33*(1-0.7)/2 */
        left: 5%;
    }
`;

export const LiveStreamingNavigationNextButtonDefaultBox = styled(LiveStreamingNavigationCommonBox)`
    right: 1rem;
    @media ${({theme}) => theme.mediaQuery.xlAndAbove} {
        /* On PC, one tile is a third of the swiper, but the ones not in center are scaled to 0.7  */
        /* right is 33.33*(1-0.7)/2 */
        right: 5%;
    }
`;

const LiveStreamingCutCommonBox = styled.div`
    position: absolute;
    height: 80%;
    width: 2px;
    top: 10%;
`;

export const LiveStreamingLeftCutDefaultBox = styled(LiveStreamingCutCommonBox)`
    left: 8%;
    margin-left: -6px;

    ${CssRule.For.RTL.build()} & {
        left: unset;
        margin-left: 0px;
        right: 8%;
        margin-right: 6px;
    }
`;
export const LiveStreamingRightCutDefaultBox = styled(LiveStreamingCutCommonBox)`
    right: 8%;
    margin-right: 11px;

    ${CssRule.For.RTL.build()} & {
        right: unset;
        margin-right: 0px;
        left: 8%;
        margin-left: -11px;
    }
`;
